import { Correction, Essay, DimensionScores } from '../types';
import { getTopicFromEssay } from './topicHelper';

// 获取总分等级文字
const getGradeLevel = (score: number, essayType?: string): string => {
  if (essayType === 'application') {
    // 应用文写作（满分15分）
    if (score >= 13) return '优秀';
    if (score >= 10) return '良好';
    if (score >= 7) return '中等';
    if (score >= 4) return '及格';
    return '不及格';
  } else {
    // 读后续写（满分25分）
    if (score >= 22) return '优秀';
    if (score >= 18) return '良好';
    if (score >= 14) return '中等';
    if (score >= 10) return '及格';
    return '不及格';
  }
};

// 动态生成评价文本
export const generateComments = (
  correction: Correction,
  essay?: Essay,
  dimensionScores?: DimensionScores
): string => {
  const topic = essay ? getTopicFromEssay(essay) : null;
  const essayType = topic?.essay_type || 'continuation';
  const isApplication = essayType === 'application';
  
  // 获取各维度的max_score
  const maxScores = {
    total: isApplication ? 15 : 25,
    language: dimensionScores?.language?.max_score || (isApplication ? 5 : 7),
    content: dimensionScores?.content?.max_score || (isApplication ? 6 : 9),
    coherence: dimensionScores?.coherence?.max_score || (isApplication ? 4 : 5),
    creativity: dimensionScores?.creativity?.max_score || (isApplication ? 0 : 4)
  };

  let comments = '';
  
  // 总体评价
  comments += `【总体评价】\n`;
  comments += `这是一篇${getGradeLevel(correction.total_score, essayType)}的作文，总分为${correction.total_score}分（满分${maxScores.total}分）。\n\n`;
  
  // 各维度表现
  comments += `【各维度表现】\n`;
  comments += `• 语言表达：${correction.language_score.toFixed(1)}分/${maxScores.language}分 - ${correction.language_comment || ''}\n`;
  comments += `• 内容质量：${correction.content_score.toFixed(1)}分/${maxScores.content}分 - ${correction.content_comment || ''}\n`;
  comments += `• 结构连贯：${correction.coherence_score.toFixed(1)}分/${maxScores.coherence}分 - ${correction.coherence_comment || ''}\n`;
  
  if (maxScores.creativity > 0 && correction.creativity_score > 0) {
    comments += `• 创意表达：${correction.creativity_score.toFixed(1)}分/${maxScores.creativity}分 - ${correction.creativity_comment || ''}\n`;
  }
  comments += '\n';
  
  // 优点亮点
  try {
    const feedback = correction.feedback ? JSON.parse(correction.feedback) : null;
    
    if (feedback?.strengths && feedback.strengths.length > 0) {
      comments += `【优点亮点】\n`;
      feedback.strengths.forEach((strength: string) => {
        comments += `• ${strength}\n`;
      });
      comments += '\n';
    }
    
    // 改进建议
    if (feedback?.improvement_suggestions && feedback.improvement_suggestions.length > 0) {
      comments += `【改进建议】\n`;
      feedback.improvement_suggestions.forEach((suggestion: any) => {
        comments += `• ${suggestion.aspect}：${suggestion.suggestion}\n`;
      });
      comments += '\n';
    }
    
    // 学习建议
    comments += `【学习建议】\n`;
    comments += '写作水平良好，继续努力，相信你能写出更好的文章！\n';
    
  } catch (e) {
    // 如果解析失败，返回基础评语
    comments += `【学习建议】\n`;
    comments += '继续努力，相信你能写出更好的文章！\n';
  }
  
  return comments;
};